// extracted by mini-css-extract-plugin
module.exports = {"primary":"#1E69C5"};